export const RESERVED_USERNAMES = Object.freeze([
  'admin', 'root', 'api', 'www', 'support', 'help',
  'about', 'terms', 'privacy', 'contact',
] as const);

export function validateEmail(email: string): string | null {
  if (!email.trim()) {
    return 'Email is required';
  }
  if (!/\S+@\S+\.\S+/.test(email)) {
    return 'Please enter a valid email address';
  }
  return null;
}

export function validatePassword(password: string): string | null {
  if (!password) {
    return 'Password is required';
  }
  if (password.length < 8) {
    return 'Password must be at least 8 characters';
  }
  return null;
}

export function validateUsername(username: string): string | null {
  if (!username.trim()) {
    return 'Username is required';
  }
  if (username.length < 3) {
    return 'Username must be at least 3 characters';
  }
  if (username.length > 30) {
    return 'Username must be less than 30 characters';
  }
  if (!/^[a-zA-Z0-9]+$/.test(username)) {
    return 'Username can only contain letters and numbers';
  }
  if (RESERVED_USERNAMES.includes(username.toLowerCase() as typeof RESERVED_USERNAMES[number])) {
    return 'This username is reserved and cannot be used';
  }
  return null;
}

export function formatInviteCode(input: string): string {
  const letters = input.replace(/[^A-Za-z]/g, '').toUpperCase();
  const limited = letters.substring(0, 10);
  if (limited.length > 5) {
    return limited.substring(0, 5) + '-' + limited.substring(5);
  }
  return limited;
}

export function validateInviteCode(code: string): string | null {
  if (!code.trim()) {
    return 'Invite code is required';
  }
  const normalized = code.replace(/-/g, '').toUpperCase();
  if (!/^[A-Z]{10}$/.test(normalized)) {
    return 'Invite code must be exactly 10 letters';
  }
  return null;
}
